import React from 'react';
import { useTraduzioniOspite } from '../utils/linguaOspite';

// Contenitore degli errori delle pagine: se una pagina si rompe (dato inatteso dal server, indirizzo costruito a mano)
// al posto della pagina bianca compare un messaggio con "Ricaricate". Il cambio di pagina lo azzera (chiave = indirizzo).
// Lo vede anche lo staff: la lingua è quella del cliente collegato, altrimenti quella del browser, altrimenti italiano.

const Messaggio = () => {
  const { t } = useTraduzioniOspite();
  return (
    <div role="alert" data-testid="errore-inatteso"
      style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1.5rem', background: '#0a0a0a', color: '#f3ead8', fontFamily: 'inherit' }}>
      <div style={{ maxWidth: '26rem', textAlign: 'center' }}>
        <h1 style={{ fontSize: '1.4rem', marginBottom: '.6rem' }}>{t('comune.qualcosa_non_ha_funzionato')}</h1>
        <p style={{ color: '#b8ab92', marginBottom: '1.2rem' }}>{t('comune.pagina_non_caricata')}</p>
        <button type="button" onClick={() => window.location.reload()}
          style={{ background: '#c9a24b', color: '#1a1408', border: 0, borderRadius: '999px', padding: '.7rem 1.4rem', fontWeight: 600, cursor: 'pointer' }}>
          {t('comune.ricarica_pagina')}
        </button>
        <p style={{ marginTop: '1rem' }}><a href="/" style={{ color: '#c9a24b' }}>{t('comune.torna_inizio')}</a></p>
      </div>
    </div>
  );
};

class ErroreInatteso extends React.Component {
  constructor(props) {
    super(props);
    this.state = { errore: null };
  }

  static getDerivedStateFromError(errore) {
    return { errore };
  }

  componentDidCatch(errore, info) {
    // resta nella console per chi deve capire cosa è successo
    console.error('Errore della pagina:', errore, info?.componentStack);
  }

  render() {
    if (!this.state.errore) return this.props.children;
    return <Messaggio />;
  }
}

export default ErroreInatteso;
